import React from 'react';

const PolitiqueConfidentialite = () => {
  return (
    <div className="w-full min-h-screen bg-gray-50">
      <div className="max-w-4xl mx-auto py-8 sm:py-12 px-4 sm:px-6 lg:px-8">
        <div className="bg-white shadow-sm border border-gray-200 rounded-lg p-4 sm:p-6 lg:p-8">
          <h1 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-6 sm:mb-8">Politique de Confidentialité</h1>

          <div className="space-y-4 sm:space-y-6 text-gray-700 text-sm sm:text-base">
            <section>
              <h2 className="text-lg sm:text-2xl font-semibold text-gray-800 mb-3 sm:mb-4">1. Introduction</h2>
            <p>
              L'association Crions D'Couleurs s'engage à protéger la confidentialité et la sécurité de vos
              données personnelles. Cette politique décrit comment nous collectons, utilisons
              et protégeons vos informations.
            </p>
          </section>

          <section>
            <h2 className="text-lg sm:text-2xl font-semibold text-gray-800 mb-3 sm:mb-4">2. Responsable du traitement</h2>
            <p className="mb-2"><strong>Association :</strong> Crions D'Couleurs</p>
            <p className="mb-2"><strong>Adresse :</strong> 27 Rue Notre-Dame, 35500 Vitré</p>
            <p className="mb-2"><strong>Email :</strong> <a href="mailto:crionsdcouleurs@gmail.com" className="text-blue-600 hover:underline">crionsdcouleurs@gmail.com</a></p>
            <p className="mb-2"><strong>Téléphone :</strong> 07 82 00 24 65</p>
            <p className="mb-2"><strong>Contact RGPD :</strong> <a href="mailto:crionsdcouleurs@gmail.com" className="text-blue-600 hover:underline">crionsdcouleurs@gmail.com</a></p>
            <p className="mt-3 text-sm text-gray-600">
              <em>Note : L'association n'a pas désigné de Délégué à la Protection des Données (DPO) car elle ne remplit pas les critères d'obligation (moins de 250 salariés, traitement de données de santé à petite échelle : ~150 enfants/an).</em>
            </p>
          </section>

          <section>
            <h2 className="text-lg sm:text-2xl font-semibold text-gray-800 mb-3 sm:mb-4">3. Données collectées</h2>
            <p className="mb-3">
              Nous collectons les données suivantes dans le cadre de l'inscription aux séjours :
            </p>

            <h3 className="text-base sm:text-lg font-semibold text-gray-800 mb-2 mt-4">📌 Données des parents/représentants légaux</h3>
            <ul className="list-disc list-inside space-y-2 ml-4">
              <li>Identité : nom, prénom</li>
              <li>Coordonnées : email, téléphone, adresse postale</li>
              <li>Authentification : mot de passe (hashé de manière sécurisée)</li>
              <li>Consentements RGPD : acceptation CGU, politique de confidentialité, traitement des données</li>
            </ul>

            <h3 className="text-base sm:text-lg font-semibold text-gray-800 mb-2 mt-4">📌 Données des enfants</h3>
            <ul className="list-disc list-inside space-y-2 ml-4">
              <li>Identité : nom, prénom, date et lieu de naissance</li>
              <li>Photo (identification visuelle)</li>
              <li>Consentement parental pour le traitement des données de santé</li>
            </ul>

            <h3 className="text-base sm:text-lg font-semibold text-gray-800 mb-2 mt-4">📌 Données d'inscription</h3>
            <ul className="list-disc list-inside space-y-2 ml-4">
              <li>Représentant légal et contact d'urgence</li>
              <li>Informations administratives (n° sécurité sociale, assurance)</li>
              <li>Informations financières (montant, paiement, aides accordées)</li>
              <li>Partenaire social (CAF, MSA) si applicable</li>
            </ul>

            <h3 className="text-base sm:text-lg font-semibold text-gray-800 mb-2 mt-4">⚠️ Données sensibles de santé (Article 9 RGPD)</h3>
            <p className="mb-2 text-gray-700">
              <strong>Consentement explicite requis</strong> : Les données de santé de votre enfant ne sont collectées
              qu'avec votre <strong>consentement explicite et séparé</strong>, donné lors de l'inscription à chaque séjour.
            </p>
            <ul className="list-disc list-inside space-y-2 ml-4">
              <li>Médecin traitant (nom, prénom, téléphone)</li>
              <li>Régime alimentaire spécifique</li>
              <li>Documents : fiche sanitaire, carnet de vaccination, attestation aisance aquatique</li>
            </ul>
            <p className="mt-2 text-sm text-gray-600">
              <em>Ces données sont utilisées uniquement pour assurer la sécurité et le bien-être de votre enfant durant le séjour.
              Elles sont supprimées automatiquement 1 an après la fin du séjour.</em>
            </p>
          </section>

          <section>
            <h2 className="text-lg sm:text-2xl font-semibold text-gray-800 mb-3 sm:mb-4">4. Finalités et base légale du traitement</h2>
            <p className="mb-3">Vos données sont utilisées pour les finalités suivantes :</p>

            <div className="overflow-x-auto mt-4">
              <table className="min-w-full border border-gray-300 text-sm">
                <thead className="bg-gray-100">
                  <tr>
                    <th className="border border-gray-300 px-3 py-2 text-left font-semibold">Finalité</th>
                    <th className="border border-gray-300 px-3 py-2 text-left font-semibold">Base légale (RGPD)</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td className="border border-gray-300 px-3 py-2">Gérer les inscriptions aux séjours</td>
                    <td className="border border-gray-300 px-3 py-2">Exécution d'un contrat (Art. 6.1.b)</td>
                  </tr>
                  <tr>
                    <td className="border border-gray-300 px-3 py-2">Assurer la sécurité des enfants durant les séjours</td>
                    <td className="border border-gray-300 px-3 py-2">Exécution d'un contrat (Art. 6.1.b)</td>
                  </tr>
                  <tr>
                    <td className="border border-gray-300 px-3 py-2">Traiter les données de santé</td>
                    <td className="border border-gray-300 px-3 py-2"><strong>Consentement explicite (Art. 9.2.a)</strong></td>
                  </tr>
                  <tr>
                    <td className="border border-gray-300 px-3 py-2">Gestion comptable et financière</td>
                    <td className="border border-gray-300 px-3 py-2">Obligation légale (Art. 6.1.c) - Conservation 10 ans</td>
                  </tr>
                  <tr>
                    <td className="border border-gray-300 px-3 py-2">Sécurité des comptes (protection brute force)</td>
                    <td className="border border-gray-300 px-3 py-2">Intérêt légitime (Art. 6.1.f)</td>
                  </tr>
                  <tr>
                    <td className="border border-gray-300 px-3 py-2">Communications relatives aux inscriptions</td>
                    <td className="border border-gray-300 px-3 py-2">Exécution d'un contrat (Art. 6.1.b)</td>
                  </tr>
                  <tr>
                    <td className="border border-gray-300 px-3 py-2">Newsletters (à venir)</td>
                    <td className="border border-gray-300 px-3 py-2">Consentement (Art. 6.1.a) - Opt-in requis</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </section>

          <section>
            <h2 className="text-lg sm:text-2xl font-semibold text-gray-800 mb-3 sm:mb-4">5. Conservation des données</h2>
            <p className="mb-3">
              Vos données sont conservées pendant la durée nécessaire aux finalités pour
              lesquelles elles ont été collectées, conformément aux obligations légales
              applicables.
            </p>
            <div className="overflow-x-auto mt-4">
              <table className="min-w-full border border-gray-300 text-sm">
                <thead className="bg-gray-100">
                  <tr>
                    <th className="border border-gray-300 px-3 py-2 text-left font-semibold">Type de données</th>
                    <th className="border border-gray-300 px-3 py-2 text-left font-semibold">Durée de conservation</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td className="border border-gray-300 px-3 py-2">Comptes parents inactifs</td>
                    <td className="border border-gray-300 px-3 py-2">3 ans après la dernière connexion (email de rappel avant suppression)</td>
                  </tr>
                  <tr>
                    <td className="border border-gray-300 px-3 py-2">Données des enfants</td>
                    <td className="border border-gray-300 px-3 py-2">Jusqu'à exercice du droit à l'oubli par le parent</td>
                  </tr>
                  <tr>
                    <td className="border border-gray-300 px-3 py-2">Données comptables (obligation légale)</td>
                    <td className="border border-gray-300 px-3 py-2"><strong>10 ans</strong> (archivées et chiffrées)</td>
                  </tr>
                  <tr>
                    <td className="border border-gray-300 px-3 py-2">Documents uploadés (hors comptables)</td>
                    <td className="border border-gray-300 px-3 py-2">1 an après la fin du séjour</td>
                  </tr>
                  <tr>
                    <td className="border border-gray-300 px-3 py-2">Données de santé</td>
                    <td className="border border-gray-300 px-3 py-2">1 an après la fin du séjour</td>
                  </tr>
                  <tr>
                    <td className="border border-gray-300 px-3 py-2">Logs de connexion</td>
                    <td className="border border-gray-300 px-3 py-2">90 jours (parents) / 1 an (administrateurs)</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </section>

          <section>
            <h2 className="text-lg sm:text-2xl font-semibold text-gray-800 mb-3 sm:mb-4">6. Destinataires des données</h2>
            <p className="mb-3">
              <strong>Vos données personnelles ne sont jamais vendues.</strong>
            </p>

            <h3 className="text-base sm:text-lg font-semibold text-gray-800 mb-2 mt-4">🔹 Destinataires internes</h3>
            <ul className="list-disc list-inside space-y-2 ml-4">
              <li>Administrateurs de l'association (gestion des inscriptions)</li>
              <li>Équipes d'encadrement des séjours (données strictement nécessaires à la sécurité et au bien-être des enfants)</li>
            </ul>

            <h3 className="text-base sm:text-lg font-semibold text-gray-800 mb-2 mt-4">🔹 Destinataires externes</h3>
            <ul className="list-disc list-inside space-y-2 ml-4">
              <li><strong>Partenaires sociaux</strong> : uniquement si inscription via partenaire (CAF, MSA)</li>
              <li><strong>Sous-traitants</strong> :
                <ul className="list-disc list-inside ml-6 mt-2 space-y-1">
                  <li>Hébergeur : <strong>OVH Cloud</strong> (stockage des données, localisation : France/UE)</li>
                  <li>Service SMTP : envoi d'emails transactionnels</li>
                </ul>
              </li>
              <li>Autorités compétentes en cas d'obligation légale</li>
            </ul>

            <h3 className="text-base sm:text-lg font-semibold text-gray-800 mb-2 mt-4">🌍 Transferts hors Union Européenne</h3>
            <p className="text-gray-700">
              <strong>Aucun transfert</strong> de vos données personnelles n'est effectué en dehors de l'Union Européenne.
            </p>
          </section>

          <section>
            <h2 className="text-lg sm:text-2xl font-semibold text-gray-800 mb-3 sm:mb-4">7. Sécurité des données</h2>
            <p>
              Nous mettons en œuvre des mesures techniques et organisationnelles appropriées
              pour protéger vos données contre tout accès non autorisé, perte ou destruction.
              Les connexions sont sécurisées et les données sensibles sont chiffrées.
            </p>
          </section>

          <section>
            <h2 className="text-lg sm:text-2xl font-semibold text-gray-800 mb-3 sm:mb-4">8. Vos droits RGPD</h2>
            <p className="mb-3">Conformément au RGPD (UE 2016/679), vous disposez des droits suivants :</p>

            <h3 className="text-base sm:text-lg font-semibold text-gray-800 mb-2 mt-4">✅ Droits exercés directement sur votre compte</h3>
            <ul className="list-disc list-inside space-y-2 ml-4">
              <li><strong>Droit d'accès</strong> (Art. 15) : Obtenez une copie complète de vos données au format JSON
                <br /><span className="text-sm text-gray-600 ml-6">➡️ <em>Profil utilisateur {">"} "Exporter mes données"</em></span>
              </li>
              <li><strong>Droit de rectification</strong> (Art. 16) : Corrigez vos données personnelles
                <br /><span className="text-sm text-gray-600 ml-6">➡️ <em>Profil utilisateur {">"} "Modifier mes informations"</em></span>
              </li>
              <li><strong>Droit à l'effacement / Droit à l'oubli</strong> (Art. 17) : Supprimez votre compte et vos données personnelles
                <br /><span className="text-sm text-gray-600 ml-6">➡️ <em>Profil utilisateur {">"} "Supprimer mon compte"</em></span>
                <br /><span className="text-sm text-gray-600 ml-6"><strong>Note :</strong> Les données comptables sont conservées 10 ans (chiffrées) conformément aux obligations légales</span>
              </li>
              <li><strong>Droit à la portabilité</strong> (Art. 20) : Recevez vos données dans un format structuré et réutilisable (JSON)
                <br /><span className="text-sm text-gray-600 ml-6">➡️ <em>Profil utilisateur {">"} "Exporter mes données"</em></span>
              </li>
            </ul>

            <h3 className="text-base sm:text-lg font-semibold text-gray-800 mb-2 mt-4">📧 Droits nécessitant une demande par email</h3>
            <ul className="list-disc list-inside space-y-2 ml-4">
              <li><strong>Droit d'opposition</strong> (Art. 21) : Opposez-vous au traitement de vos données (ex : newsletters)
                <br /><span className="text-sm text-gray-600 ml-6">➡️ <em>Envoyez un email à : <a href="mailto:crionsdcouleurs@gmail.com" className="text-blue-600 hover:underline">crionsdcouleurs@gmail.com</a></em></span>
              </li>
              <li><strong>Droit à la limitation du traitement</strong> (Art. 18) : Limitez temporairement le traitement de vos données
                <br /><span className="text-sm text-gray-600 ml-6">➡️ <em>Envoyez un email à : <a href="mailto:crionsdcouleurs@gmail.com" className="text-blue-600 hover:underline">crionsdcouleurs@gmail.com</a></em></span>
              </li>
            </ul>

            <p className="mt-4 p-3 bg-blue-50 border-l-4 border-blue-500 text-sm">
              <strong>Délai de réponse :</strong> Nous nous engageons à répondre à vos demandes dans un délai maximum de <strong>1 mois</strong> à compter de la réception de votre demande.
            </p>

            <h3 className="text-base sm:text-lg font-semibold text-gray-800 mb-2 mt-4">⚖️ Droit de réclamation auprès de la CNIL</h3>
            <p className="text-gray-700">
              Si vous estimez que vos droits ne sont pas respectés, vous pouvez introduire une réclamation auprès de la Commission Nationale de l'Informatique et des Libertés (CNIL) :
            </p>
            <ul className="list-disc list-inside space-y-2 ml-4 mt-2">
              <li><strong>En ligne :</strong> <a href="https://www.cnil.fr/fr/plaintes" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">www.cnil.fr/fr/plaintes</a></li>
              <li><strong>Par courrier :</strong> CNIL - 3 Place de Fontenoy - TSA 80715 - 75334 PARIS CEDEX 07</li>
            </ul>
          </section>



          <section>
            <h2 className="text-lg sm:text-2xl font-semibold text-gray-800 mb-3 sm:mb-4">9. Modifications</h2>
            <p>
              Nous nous réservons le droit de modifier cette politique de confidentialité.
              Toute modification sera publiée sur cette page avec une mise à jour de la date
              de dernière modification.
            </p>
          </section>

          <section>
            <h2 className="text-lg sm:text-2xl font-semibold text-gray-800 mb-3 sm:mb-4">10. Contact et exercice de vos droits</h2>
            <p className="mb-3">
              Pour toute question concernant cette politique de confidentialité, le traitement de vos données personnelles,
              ou pour exercer vos droits RGPD :
            </p>
            <div className="mt-3 ml-4 space-y-2">
              <p><strong>Responsable du traitement :</strong> Association Crions D'Couleurs</p>
              <p><strong>Adresse :</strong> 27 Rue Notre-Dame, 35500 Vitré</p>
              <p><strong>Email RGPD :</strong> <a href="mailto:crionsdcouleurs@gmail.com" className="text-blue-600 hover:underline">crionsdcouleurs@gmail.com</a></p>
              <p><strong>Téléphone :</strong> 07 82 00 24 65</p>
            </div>

            <p className="mt-4 p-3 bg-yellow-50 border-l-4 border-yellow-500 text-sm">
              <strong>📋 Registre des traitements :</strong> Consultable sur demande auprès de l'association (obligatoire selon l'Article 30 du RGPD).
            </p>
          </section>
        </div>

          <div className="mt-6 sm:mt-8 pt-4 sm:pt-6 border-t border-gray-200">
            <p className="text-xs sm:text-sm text-gray-500">
              Dernière mise à jour : 16/01/2025 - Conformité RGPD renforcée
            </p>
            <p className="text-xs text-gray-400 mt-1">
              Version 2.0 - Ajout consentement santé explicite (Art. 9 RGPD), durées de conservation détaillées, procédures d'exercice des droits
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PolitiqueConfidentialite;
